// extracted by mini-css-extract-plugin
module.exports = {"_newSelectOption":"SpeditionAuswahl__newSelectOption__iAL9Z"};